
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Nein. Solange Sie die Hände waschen, bevor Sie Ihr Gesicht berühren, ist das
  ungefährlich. Virale Tröpfchen können nicht durch die Haut gelangen.
    </p>
    <h5>Bereiche der Hände werden beim Waschen oft vergessen</h5>
    <Image className='cbImage' file={require('images/illus_notwashed.jpg')} mdxType="Image"> 
      <div className='handAreasKey'>
    <div className='entry'>
    <div className='color red' />
    <div className='label'>am meisten vergessen</div>
    </div>
        <div className='entry'>
    <div className='color orange' />
    <div className='label'>oft vergessen</div>
    </div>
    <div className='entry'>
    <div className='color yellow' />
    <div className='label'>gelegentlich vergessen</div>
    </div>
    </div>
    </Image>
    <div className='caption noMargin'>Diese schon etwas in die Jahre gekommene Visualisierung ist
                wieder brandaktuell. Sie zeigt, wie gut das
                US-Gesundheitspersonal sich die Hände wäscht und welche Bereiche
                oft vergessen gehen. Viele Menschen waschen nur die
                Handinnenflächen, Sie sollten aber alle Bereiche der Hand
                gründlich abreiben. Quelle:Taylor, LJ. An evaluation of handwashingtechniques. NursingTimes. Januar 1978.</div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;